import { Component, inject } from '@angular/core';
import {
  ActionComponentNew,
  ActionResult,
  AuthRequestOptions,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { JedinicaGradiva } from '@app/shared/models/jedinica-gradiva';
import { appConfigService } from '@app/config';
import { HttpClient } from '@angular/common/http';
import { EMPTY, first, map } from 'rxjs';

@Component({
  selector: 'app-micanje-jedinice-iz-istaknutog-sadrzaja',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class MicanjeJediniceIzIstaknutogSadrzajaComponent extends ActionComponentNew<ActionResult> {
  private listviewProvider = inject(ListViewProviderDirective);

  constructor(protected override notificationService: NotificationService) {
    super(notificationService);
  }

  private httpClient = inject(HttpClient);
  private config = inject(appConfigService);

  private selectedItems: object[] = [];

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.listviewProvider.selectedItems$.pipe(
      map((selectedItems) => {
        this.selectedItems = selectedItems;
        return selectedItems.length < 1;
      })
    );
  }

  public refresh() {
    this.listviewProvider.refresh();
  }

  protected doExecute() {
    console.log('selectedItems: ' + this.selectedItems);
    const jedinice = this.selectedItems as JedinicaGradiva[];
    console.log('jedinice: ' + jedinice);
    const formData = jedinice.map((jg) => jg['en~jedinica_gradiva~id']);

    this.httpClient
      .post(
        `${this.config.apiHost}istaknuti-sadrzaj/micanje-jedinica`,
        formData,
        new AuthRequestOptions()
      )
      .pipe(first())
      .subscribe({
        next: () => {
          const message =
            jedinice.length > 1
              ? 'Jedinice gradiva uspješno uklonjene'
              : 'Jedinica gradiva uspješno uklonjene';
          this.notificationService.success(message);
          this.listviewProvider.refresh();
        },
        error: () => {
          const errorMessage =
            jedinice.length > 1
              ? 'Greška pri uklanjanju jedinica gradiva'
              : 'Greška pri uklanjanju jedinice gradiva';
          this.notificationService.error(errorMessage);
        }
      });
    return EMPTY;
  }
}
